(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["SiteGen"] = factory();
	else
		root["SiteGen"] = root["SiteGen"] || {}, root["SiteGen"]["CoreLoader"] = root["SiteGen"]["CoreLoader"] || {}, root["SiteGen"]["CoreLoader"]["2.25.4"] = factory();
})(self, () => {
return 